import { GenericAnalyticsClient } from '@acorns/web-utils'
import { ApolloLink } from 'apollo-link'

import { trackLoadingTimeSduiPricingScreenLoadedPayload } from 'generated/trackingEvents'

export const createTimingLink = (analytics: GenericAnalyticsClient) =>
  new ApolloLink((operation, forward) => {
    if (
      operation.operationName !== 'GetBlueprint' ||
      operation.variables?.screen !== 'CHANGE_PLAN'
    ) {
      return forward(operation)
    }

    const startTime = performance.now()

    return forward(operation).map((response) => {
      if (response.data?.blueprint?.__typename === 'BlueprintDoc') {
        const endTime = performance.now()
        const deltaSeconds = ((endTime - startTime) / 1000).toFixed(4)

        analytics.track(
          ...trackLoadingTimeSduiPricingScreenLoadedPayload({ deltaSeconds }),
        )
      }
      return response
    })
  })
